module.exports = __webpack_public_path__ + "db56a3261a587c3ec2ad015ef013e9c3.pdf";